import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Select from 'react-select';
import Constants from '../../config/constants';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle, searchData } from '../datatable/util';
import {
  addWaterPumpToACCentral,
  removeWaterPumpFromACCentral,
  editWaterPumpInACCentral,
  addToBeCreatedWaterPump,
  editToBeCreatedWaterPump,
  removeToBeCreatedWaterPump,
} from '../../redux/ac_central/ac_central_actions';
import { searchWaterPumpByText } from '../../redux/ac_central/water_pump_actions';
import { defaultRejectHandler } from '../../utils/utility';

export class WaterPumpDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'water_pump.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'water_pump.name',
        width: 200,
        ...textColumn,
        entity: {
          list: (text, page) => searchWaterPumpByText(text, page)
            .then(response => response.data.map((water_pump) => ({label: water_pump.name, value: String(water_pump.id), original: water_pump}))),
          create: null,
        },
      },
      {
        Header: () => <b>{t('water pump type')}</b>,
        accessor: 'water_pump.type',
        ...textColumn,
        width: 200,
      },
      {
        Header: () => <b>{t('power (kW)')}</b>,
        accessor: 'water_pump.power_required',
        ...coeColumn,
        width: 200,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...decimalColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
    ];

    this.state = {
      isShowCreateAC: false,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;
    if(filter!== undefined){
      this.setState({ search: filter })
    }
    this.setState({ categoryOption: category });
  }

  editItem(item) {
    this.setState({
        isShowEditModal: true,
        selectedItem: item.original,
      },
      () => {
        if (this.props.onEditItem) {
          this.props.onEditItem(this.state.selectedItem);
        }
      },
    );
  }
  
  render() {
    const {
      categoryOption,
      selectedItem: item,
      search,
    } = this.state;

    const {
      acCentralId,
      filtered,
      filteredCount,
      isLoading,
      addWaterPump,
      removeWaterPump,
      editWaterPump,
      isWaterPumpAdding,
      isWaterPumpEditing,
      isWaterPumpRemoving,
      waterPumps,
      addToBeCreatedWaterPump,
      editToBeCreatedWaterPump,
      removeToBeCreatedWaterPump,
      mode,
      t,
    } = this.props;

    const accessor = (data) => data && data.water_pump;

    const relationship = {
      create: (({ entityId, quantity, original }) => {        
        if (mode === 'edit'){
          addWaterPump(acCentralId, entityId, quantity);
        } else{
          addToBeCreatedWaterPump(quantity, original, this.props.waterPumps);
        }
      }).bind(this),
      edit: ({ id, quantity, water_pump }) => {
        if (mode === 'edit'){
          editWaterPump(id, quantity);
        } else{
          editToBeCreatedWaterPump(water_pump.id, quantity);
        }
      },
      delete: (id, rel) => {
        if (mode === 'edit'){
          removeWaterPump(id, acCentralId)
        } else{
          removeToBeCreatedWaterPump(rel.water_pump.id);
        }
      },
      isCreating: isWaterPumpAdding,
      isEditing: isWaterPumpEditing,
      isDeleting: isWaterPumpRemoving,
    };
    return (
      <div>
        <div style={{ backgroundColor: 'white' }}>

          <div className="filter-box" style={{ display: 'flex', padding: 20, marginBottom: 20 }}>
            <input
              className="text-search"
              style={{ width: 240, height: 36, margin: 10 }}
              type="text"
              onChange={event => this.updateSortFilter(event.target.value, null, categoryOption)}
              placeholder={t('search name')}
            />
            <Select
              className="react-select-container"
              classNamePrefix="react-select"
              style={{ width: 160, margin: 10 }}
              value={categoryOption}
              placeholder={t('category')}
              onChange={option => this.updateSortFilter(filtered, null, option)}
              options={[
                { value: 'all', label: t('all') },
                { value: 'public', label: t('public') },
                { value: 'private', label: t('private') },
              ]}
            />
          </div>

          <RelationDataTable
            columns={this.columns}
            data={searchData(search, categoryOption, waterPumps, accessor)}
            relationship={relationship}
            relationshipNameAccessor={item => item.water_pump.name}
            classNamePrefix="select-central-unit-water-pump"
            onActionEdit={item => this.editItem(item)}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isWaterPumpAdding: state.ac.central.isWaterPumpAdding,
  isWaterPumpEditing: state.ac.central.isWaterPumpEditing,
  isWaterPumpRemoving: state.ac.central.isWaterPumpRemoving,
});

const mapDispatchToProps = dispatch => ({
  addWaterPump: (acCentralId, waterPumpId, quantity) => defaultRejectHandler(dispatch(addWaterPumpToACCentral(acCentralId, waterPumpId, quantity))),
  addToBeCreatedWaterPump: (quantity, water_pump, tobecreatedwaterpumparry) => defaultRejectHandler(dispatch(addToBeCreatedWaterPump(quantity, water_pump, tobecreatedwaterpumparry))),
  removeWaterPump: (acCentralWaterPumpId, acCentralId) => defaultRejectHandler(dispatch(removeWaterPumpFromACCentral(acCentralWaterPumpId, acCentralId))),
  removeToBeCreatedWaterPump: (waterPumpId) => defaultRejectHandler(dispatch(removeToBeCreatedWaterPump(waterPumpId))),
  editWaterPump: (acCentralWaterPumpId, quantity) => defaultRejectHandler(dispatch(editWaterPumpInACCentral(acCentralWaterPumpId, quantity))),
  editToBeCreatedWaterPump: (waterPumpId, quantity) => defaultRejectHandler(dispatch(editToBeCreatedWaterPump(waterPumpId, quantity))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(WaterPumpDataTable),
);



// WEBPACK FOOTER //
// ./src/components/ac_central/WaterPumpDataTable.js